import { postJson } from './client'
import type { PasswordReset } from '../types/account'

// The person's own account. Changing your password is not an admin surface and carries no user id:
// the API decides who you are from the session, the same way /voice does.
const password = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/account/password`
const reset = (spoke: string, userId: string) =>
  `/api/spokes/${encodeURIComponent(spoke)}/scout/users/${encodeURIComponent(userId)}/password/reset`

export const accountApi = {
  /** 204 on success. A wrong current password, one under the floor, or the same one again is a refusal. */
  changePassword: (spoke: string, currentPassword: string, newPassword: string) =>
    postJson<void>(password(spoke), { currentPassword, newPassword }),

  /**
   * Mints a temporary password for somebody who cannot get in (admins only). The reply is the only
   * copy: show it, let them copy it, and never cache or re-request it.
   */
  resetPassword: (spoke: string, userId: string) => postJson<PasswordReset>(reset(spoke, userId)),
}
